/*
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * AppDispatcher
 *
 * A singleton that operates as the central hub for application updates.
 */
import type {Callback, DispatchAction} from './DispatchTypes';
// import Events from '../logging/Events';

class AppDispatcher {
  _callbacks: Callback[] = [];

  /**
   * Register a Store's callback so that it may be invoked by an action.
   * @param callback The callback to be registered.
   * @return The index of the callback within the _callbacks array.
   */
  register(callback: Callback): number {
    this._callbacks.push(callback);

    return this._callbacks.length - 1;
  }

  async handleViewAction(action: DispatchAction) {
    await Promise.all(
      this._callbacks.map(async (callback) => {
        try {
          await callback(action);
        } catch (e) {
          // Events.Error.trackEvent(
          //   'Exception',
          //   'AppDispatcher:handleViewAction',
          //   e.message ? e.message : e.toString(),
          // );
        }
      }),
    );
  }
}

export default new AppDispatcher();
